var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_vm._t("head")],2),_c('div',{staticClass:"body",class:_vm.scrollableBody ? 'custom-scrollbar' : ''},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }